// Translations for the MyId page (MyId.js) - member's own digital ID/QR view.
const myIdDict = [
  { en: "Failed to load ID card", sw: "Imeshindwa kupakia kadi ya utambulisho" },
  { en: "Loading your ID card...", sw: "Inapakia kadi yako ya utambulisho..." },
  { en: "My Digital ID Card", sw: "Kadi Yangu ya Utambulisho ya Kidijitali" },
  { en: "Your official TAREWU membership identification", sw: "Kitambulisho chako rasmi cha uanachama wa TAREWU" },
  { en: "No ID Card Found", sw: "Hakuna Kadi ya Utambulisho Iliyopatikana" },
  { en: "You don't have an active ID card yet.", sw: "Bado huna kadi ya utambulisho inayotumika." },
  { en: "Please contact the union administrator to request your digital ID card.", sw: "Tafadhali wasiliana na msimamizi wa chama ili kuomba kadi yako ya utambulisho ya kidijitali." },
  { en: "PREMIUM", sw: "PREMIUM" },
  { en: "STANDARD", sw: "KAWAIDA" },
  { en: "Card No:", sw: "Namba ya Kadi:" },
  { en: "Issue Date:", sw: "Tarehe ya Kutolewa:" },
  { en: "Expiry Date:", sw: "Tarehe ya Mwisho:" },
  { en: "Card Status", sw: "Hali ya Kadi" },
  { en: "Payment Status", sw: "Hali ya Malipo" },
  { en: "Card Type", sw: "Aina ya Kadi" },
  { en: "Premium", sw: "Premium" },
  { en: "Standard", sw: "Kawaida" },
  { en: "Amount Paid", sw: "Kiasi Kilicholipwa" },
  { en: "Download PDF", sw: "Pakua PDF" },
  { en: "Refresh", sw: "Onyesha Upya" },
  { en: "Important Information", sw: "Taarifa Muhimu" },
  { en: "This digital ID card is valid for identification purposes within the union.", sw: "Kadi hii ya utambulisho ya kidijitali ni halali kwa madhumuni ya utambulisho ndani ya chama." },
  { en: "Present this card when accessing union services or attending meetings.", sw: "Onyesha kadi hii unapopata huduma za chama au kuhudhuria mikutano." },
  { en: "Keep your card safe and don't share your card number with strangers.", sw: "Hifadhi kadi yako salama na usishiriki namba ya kadi yako na wageni." },
  { en: "Contact the administrator if your card is lost or damaged.", sw: "Wasiliana na msimamizi endapo kadi yako imepotea au imeharibika." },
];

export default myIdDict;
